/* oxlint-disable no-underscore-dangle */
/**
 * Config resuelta en RUNTIME (estrategia build-once → promote dev→staging→prod).
 *
 * - Web/PWA: el contenedor inyecta `window.__APP_CONFIG__` vía `/config.js` (lo genera
 *   el entrypoint de nginx desde variables de entorno al arrancar). Una sola imagen
 *   sirve todos los entornos; solo cambian las env del contenedor.
 * - Tauri (escritorio/móvil): no hay `/config.js`; cae a los valores horneados de
 *   `import.meta.env.VITE_*` (build-time) → comportamiento intacto.
 * - Dev local: idem (import.meta.env desde apps/web/.env) o fallback a localhost.
 */
interface AppRuntimeConfig {
  SERVER_URL?: string;
  POWERSYNC_URL?: string;
}

const runtime: AppRuntimeConfig =
  (globalThis as typeof globalThis & { __APP_CONFIG__?: AppRuntimeConfig }).__APP_CONFIG__ ?? {};

/** Base del backend (auth/api/server). */
export const SERVER_URL: string =
  runtime.SERVER_URL ??
  import.meta.env.VITE_SERVER_URL ??
  import.meta.env.VITE_API_URL ??
  "http://localhost:3333";

/** Endpoint del servicio PowerSync. */
export const POWERSYNC_URL: string =
  runtime.POWERSYNC_URL ?? import.meta.env.VITE_POWERSYNC_URL ?? "http://localhost:8085";
